export interface Link {
  href: string;
  target?: '_self' | '_blank' | '_parent' | '_top';
}

export interface Links {
  appStore: Link;
  playMarket: Link;
  instagram: Link;
  discord: Link;
  twitter: Link;
}

export interface WrapperSize {
  width: number;
  height: number;
}

export const links: Links = {
  appStore: {
    href: '#',
    target: '_blank'
  },
  playMarket: {
    href: '#',
    target: '_blank'
  },
  instagram: {
    href: '#',
    target: '_blank'
  },
  discord: {
    href: '#',
    target: '_blank'
  },
  twitter: {
    href: '#',
    target: '_blank'
  }
};

export const wrapperSize: WrapperSize = {
  width: 2880,
  height: 1600
};

export const animationDuration = 2000;